import { createContext, useContext } from "react"

type ResponsiveContext = {
  useVerticalCards: boolean
  isMobile: boolean
}

const initialValues = {
  useVertical: false,
  isMobile: false
}

export const ResponsiveContext = createContext(initialValues)

export const useResponxiveContext = () => useContext(ResponsiveContext)

